var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1149,
    height: 375,
    viewBox: "0 0 1149 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 229.03L48.173 255.655L157.168 192.422L109.329 165.797L2 229.03Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26172 294.085L48.4347 320.709L157.43 257.476L109.59 230.859L2.26172 294.085Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1758 255.654V320.709",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.289 191.824V256.886",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 228.564V295.309",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1719 255.057L94.3525 281.682L203.34 218.449L155.501 191.824L48.1719 255.057Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4336 320.12L94.6143 346.737L203.602 283.512L155.762 256.887L48.4336 320.12Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3516 281.682V346.736",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.461 217.853V282.915",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1719 254.6V321.336",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2 163.975L48.173 190.592L157.168 127.367L109.329 100.742L2 163.975Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26172 229.03L48.4347 255.655L157.43 192.422L109.59 165.797L2.26172 229.03Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1758 190.593V255.655",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M156.289 126.771V191.825",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2 163.51V230.254",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4336 190.004L94.6143 216.628L203.602 153.395L155.762 126.771L48.4336 190.004Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6953 255.058L94.8683 281.683L203.863 218.45L156.024 191.825L48.6953 255.058Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6133 216.628V281.682",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M202.723 152.799V217.853",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4336 189.538V256.282",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6602 281.65L140.841 308.275L249.828 245.042L201.989 218.417L94.6602 281.65Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9219 346.705L141.103 373.33L250.09 310.097L202.251 283.472L94.9219 346.705Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M140.84 308.274V373.329",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M248.949 244.445V309.5",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6602 281.185V347.929",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9219 216.588L141.103 243.213L250.09 179.98L202.251 153.355L94.9219 216.588Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1836 281.651L141.364 308.268L250.352 245.043L202.512 218.418L95.1836 281.651Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.102 243.213V308.275",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M249.211 179.391V244.445",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9219 216.131V282.875",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2 99.1373L48.173 125.762L157.168 62.5291L109.329 35.9043L2 99.1373Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26172 164.193L48.4347 190.818L157.43 127.585L109.59 100.968L2.26172 164.193Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1758 125.762V190.816",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M156.289 61.9326V126.995",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2 98.6719V165.416",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4336 125.165L94.6143 151.789L203.602 88.5565L155.762 61.9316L48.4336 125.165Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6953 190.219L94.8683 216.844L203.863 153.619L156.024 126.994L48.6953 190.219Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6133 151.789V216.844",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M202.723 87.96V153.022",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4336 124.699V191.443",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9219 151.758L141.103 178.375L250.09 115.15L202.251 88.5254L94.9219 151.758Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1836 216.813L141.364 243.438L250.352 180.205L202.512 153.58L95.1836 216.813Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.102 178.376V243.438",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M249.211 114.554V179.608",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9219 151.292V218.036",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M719.348 229.029L765.528 255.654L874.516 192.421L826.676 165.796L719.348 229.029Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M719.609 294.084L765.782 320.709L874.777 257.475L826.938 230.858L719.609 294.084Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M765.527 255.653V320.708",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M873.637 191.824V256.886",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M719.348 228.563V295.308",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M765.531 255.057L811.704 281.682L920.692 218.449L872.852 191.824L765.531 255.057Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M765.785 320.12L811.966 346.737L920.953 283.512L873.114 256.887L765.785 320.12Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M811.707 281.682V346.736",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M919.816 217.853V282.915",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M765.531 254.6V321.336",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M719.348 163.973L765.528 190.59L874.516 127.365L826.676 100.74L719.348 163.973Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M719.609 229.028L765.782 255.653L874.777 192.42L826.938 165.795L719.609 229.028Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M765.527 190.591V255.653",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M873.637 126.769V191.823",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M719.348 163.508V230.252",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M765.789 190.002L811.97 216.626L920.957 153.393L873.118 126.769L765.789 190.002Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M766.051 255.056L812.232 281.681L921.219 218.448L873.38 191.823L766.051 255.056Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M811.969 216.626V281.68",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M920.078 152.797V217.851",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M765.789 189.535V256.279",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.35 65.233L1038.17 91.8578L929.18 28.6248L977.019 2L1084.35 65.233Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.09 130.288L1037.91 156.913L928.918 93.6795L976.757 67.0547L1084.09 130.288Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.18 91.8574V156.912",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M930.059 28.0283V93.0906",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.35 64.7676V131.512",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M991.008 195.127L1037.18 221.751L1146.18 158.518L1098.34 131.894L991.008 195.127Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M991.27 260.181L1037.44 286.806L1146.44 223.573L1098.6 196.948L991.27 260.181Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.18 221.751V286.806",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.3 157.922V222.984",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M991.008 194.661V261.405",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M719.348 99.1373L765.528 125.762L874.516 62.5291L826.676 35.9043L719.348 99.1373Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M719.609 164.192L765.782 190.817L874.777 127.584L826.938 100.967L719.609 164.192Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M765.527 125.762V190.816",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M873.637 61.9326V126.995",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M719.348 98.6719V165.416",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M821.383 92.6344L867.556 119.259L976.551 56.0262L928.712 29.4092L821.383 92.6344Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M821.645 157.697L867.817 184.322L976.813 121.089L928.973 94.4639L821.645 157.697Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M867.559 119.26V184.322",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M975.672 55.4375V120.492",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M821.383 92.1758V158.92",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M991.008 130.288L1037.18 156.913L1146.18 93.6795L1098.34 67.0547L991.008 130.288Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M991.27 195.35L1037.44 221.967L1146.44 158.742L1098.6 132.117L991.27 195.35Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.18 156.912V221.967",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.3 93.083V158.145",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M991.008 129.83V196.567",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M338.742 229.029L384.915 255.654L493.91 192.421L446.071 165.796L338.742 229.029Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M339.004 294.084L385.177 320.709L494.172 257.475L446.333 230.858L339.004 294.084Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M384.918 255.653V320.708",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M493.027 191.824V256.886",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M338.742 228.563V295.308",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M384.91 255.057L431.091 281.682L540.078 218.449L492.239 191.824L384.91 255.057Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M385.172 320.12L431.345 346.737L540.34 283.512L492.501 256.887L385.172 320.12Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M431.09 281.682V346.736",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M539.199 217.853V282.915",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M384.91 254.6V321.336",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M338.742 163.973L384.915 190.59L493.91 127.365L446.071 100.74L338.742 163.973Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M339.004 229.028L385.177 255.653L494.172 192.42L446.333 165.795L339.004 229.028Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M384.918 190.591V255.653",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M493.027 126.769V191.823",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M338.742 163.508V230.252",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M431.926 162.974L478.106 189.599L587.094 126.366L539.254 99.7412L431.926 162.974Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M432.188 228.029L478.361 254.654L587.356 191.421L539.516 164.796L432.188 228.029Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M478.105 189.599V254.653",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M586.215 125.77V190.832",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M431.926 162.509V229.253",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M431.398 281.65L477.579 308.275L586.567 245.042L538.727 218.417L431.398 281.65Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M431.66 346.705L477.841 373.33L586.828 310.097L538.989 283.472L431.66 346.705Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M477.578 308.274V373.329",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M585.688 244.445V309.5",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M431.398 281.185V347.929",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M478.418 189.561L524.599 216.186L633.586 152.953L585.747 126.328L478.418 189.561Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M478.68 254.624L524.86 281.241L633.848 218.015L586.008 191.391L478.68 254.624Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M524.598 216.186V281.248",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M632.707 152.363V217.418",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M478.418 189.104V255.848",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M338.742 99.1373L384.915 125.762L493.91 62.5291L446.071 35.9043L338.742 99.1373Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M339.004 164.192L385.177 190.817L494.172 127.584L446.333 100.967L339.004 164.192Z",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M384.918 125.762V190.816",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M493.027 61.9326V126.995",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M338.742 98.6719V165.416",
    stroke: "white",
    strokeWidth: 1.44944,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M431.926 98.1373L478.106 124.762L587.094 61.5292L539.254 34.9043L431.926 98.1373Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M432.188 163.192L478.361 189.817L587.356 126.592L539.516 99.9668L432.188 163.192Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M478.105 124.762V189.816",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M586.215 60.9326V125.995",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M431.926 97.6719V164.416",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M478.418 124.73L524.599 151.347L633.586 88.1219L585.747 61.4971L478.418 124.73Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M478.68 189.785L524.86 216.41L633.848 153.177L586.008 126.552L478.68 189.785Z",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M524.598 151.348V216.41",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M632.707 87.5254V152.58",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M478.418 124.265V191.009",
    stroke: "#26483E",
    strokeWidth: 2.51909,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.280a6f54608f2a88f6866cafabd3b888.svg";
export { ForwardRef as ReactComponent };